import { injectable } from 'inversify';

import { ILookupRepository } from '@/domain/repositories/lookup.repository.interface';
import { Result } from '@/entities';
import { CurrencyFormat, currencyFormats } from '@/entities/CurrencyFormat';
import { listCurrencies } from '@/infrastructure/network/data/currency';
import { CurrencyDto } from '@/infrastructure/network/dto/CurrencyDto';
import { Timezone } from '@/components/molecules/main-header/types';
import { getTimezones } from '@/infrastructure/network/data/timezones';

@injectable()
export class LookupRepository implements ILookupRepository {
	async getCurrencyFormat(currencyId: string): Promise<Result<CurrencyFormat>> {
		const result = await listCurrencies();
		const currency = result.data.find((currency) => currency.id === currencyId);
		if (result.statusCode === 200) {
			return { data: currencyFormats[currency?.abbreviation || 'USD'], statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async listAllCurrencies(): Promise<Result<CurrencyDto[]>> {
		const result = await listCurrencies();
		if (result.statusCode === 200) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async listAllTimezones(): Promise<Result<Timezone[]>> {
		const result = await getTimezones();
		if (result.statusCode === 200) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}
}
